import React from 'react';
import { makeStyles } from '@material-ui/styles';
import { MenuItem, FormControlLabel, Typography } from '@material-ui/core';
import Grid from '@material-ui/core/Grid';

import { Field } from 'formik';
import S3FileUpload from 'components/file-upload/s3-file-upload';
import FormikCheckBox from 'components/theme/formik/checkbox';
import FormikTextField from 'components/theme/formik/text-field';
import { messages } from 'app-constants';

const useStyles = makeStyles(
  (theme) => ({
    select: {
      marginLeft: theme.spacing.unit,
      marginTop: theme.spacing.unit,
      minWidth: 250
    },
    selectLabel: {
      margin: 0,
      cursor: 'default',
      whiteSpace: 'nowrap'
    },
    gridColumn: {
      flexBasis: 'auto',
      padding: [[0, theme.spacing.unit * 2, 0, 0]]
    },
    fileUpload: {
      '& .filepond--root': {
        margin: [
          [
            theme.spacing.unit * 2,
            theme.spacing.unit,
            theme.spacing.unit * 2,
            0
          ]
        ]
      }
    }
  }),
  { withTheme: true }
);

export default function ConditionUserTarget(props) {
  const classes = useStyles();

  const onUpload = () => {
    props.refetchUserSegments();
  };

  const { condition, index, userSegments = [] } = props;
  const disabled = !condition.enable;

  return (
    <>
      <FormControlLabel
        control={
          <Field
            name={`conditions[${index}].enable`}
            component={FormikCheckBox}
            color="primary"
          />
        }
        label={messages.CONDITIONS[condition.conditionType].title}
      />

      <Grid container>
        <Grid item xs={12} lg={4} className={classes.gridColumn}>
          <Field
            name={`conditions[${index}].conditionTarget`}
            render={(fieldProps) => {
              return (
                <FormControlLabel
                  className={classes.selectLabel}
                  disabled={disabled}
                  control={
                    <FormikTextField
                      select
                      disabled={disabled}
                      className={classes.select}
                      data-testid="select-user-segment"
                      {...fieldProps}
                    >
                      <MenuItem value="None">
                        <em>None</em>
                      </MenuItem>
                      {userSegments.map((us) => (
                        <MenuItem value={us.userSegmentId} key={us.uId}>
                          {us.name}
                        </MenuItem>
                      ))}
                    </FormikTextField>
                  }
                  label="User is in segment"
                  labelPlacement="start"
                />
              );
            }}
          />
        </Grid>

        <Grid item xs={12} lg={4} className={classes.gridColumn}>
          <div className={classes.fileUpload}>
            <S3FileUpload
              onUpload={onUpload}
              disabled={disabled}
              uploadLabel="Upload User Segment"
            />
          </div>
        </Grid>
      </Grid>
      <Typography
        variant="caption"
        gutterBottom
        color={disabled ? 'textSecondary' : 'default'}
      >
        Note: Only CSV files are supported; please wait for user segment list to
        get updated after file is uploaded successfully.
        <br />
        <i>Feature will turn on if user id match the condition.</i>
      </Typography>
    </>
  );
}
